const PUBLIC_KEY_PEM = `
-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAmbrvYkMxS+9pqwxFe8o0
fF5ODKMl3GplP5OjJ7kfeeUqabOCUSZ/+W82KhhZurn8ySrIwmor85wB8OhmTmct
wzdMR3U5zecCHZfCxnmHX7l8q6iGLcSmWx92rI1pm9RH6FBzBbZnKFLagBQBsuhS
WCV9bHGSZnBsN99nV05egfnNlSV5RGQN04mKkZpxAbmNm++jFI04G9bWhWbyFT6i
jwixIQZ8r9qqr4DXYy0CrPKUdSM68tGMOWP8930m0d3pmM3g3HcflaDqe6eB6seb
nne6KFLAz346wggnWXUOn32lDLlzaSFp7IMBexF1opH2h1sTxq3Df2sa1460R8Te
twIDAQAB
-----END PUBLIC KEY-----
`.trim();

const pemToArrayBuffer = pem => {
  const b64 = pem
    .replace(/-----BEGIN PUBLIC KEY-----/, '')
    .replace(/-----END PUBLIC KEY-----/, '')
    .replace(/\s+/g, '');
  const raw = window.atob(b64);
  const bytes = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) {
    bytes[i] = raw.charCodeAt(i);
  }
  return bytes.buffer;
};

const importRsaPublicKey = async pem => {
  const spkiDer = pemToArrayBuffer(pem);
  return await window.crypto.subtle.importKey(
    'spki',
    spkiDer,
    { name: 'RSA-OAEP', hash: 'SHA-256' },
    false, // not extractable
    ['encrypt']
  );
};

const utf8ToArrayBuffer = text => {
  return new TextEncoder().encode(text);
};

const arrayBufferToBase64 = buf => {
  const bytes = new Uint8Array(buf);
  let binary = '';
  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
};

/**
 * Encrypt plaintext (e.g., OTP) using RSA-OAEP(SHA-256).
 * Returns base64 ciphertext string.
 */
const encryptOtpWithPublicKey = async (otp, publicKeyPem = PUBLIC_KEY_PEM) => {
  const key = await importRsaPublicKey(publicKeyPem);
  const data = utf8ToArrayBuffer(otp);
  const ciphertext = await window.crypto.subtle.encrypt(
    { name: 'RSA-OAEP' },
    key,
    data
  );
  return arrayBufferToBase64(ciphertext);
};

export { PUBLIC_KEY_PEM, encryptOtpWithPublicKey };
